/*
 * @Author: wzc
 * @Date: 2021-06-18 09:26:38
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-30 18:33:48
 */
// import axios from 'axios'
let avatar_key = ['picture', 'country_pic']
let is_win_dom = `<div class="is_win"></div>`
let is_promote_dom = `<div class="is_promote"></div>`
export function parse_cell_data(item, key, options = {}) {
  // 'ellipsis' : 'max2line'
  let mid_win_icon = ''
  let mid_promote_icon = ''
  let {
    index,
    sub_index,
    map_key_arr = [],
    fix_table_head = [],
    free_table_head = [],
    is_fix,
    is_free,
  } = options
  if (
    index === 0 &&
    sub_index === 0 &&
    item.is_win === true &&
    ((is_fix && fix_table_head.length > 0) ||
      (is_free && fix_table_head.length === 0))
  ) {
    mid_win_icon = is_win_dom
  }
  if (
    index === 0 &&
    sub_index === 0 &&
    item.is_promote === true &&
    ((is_fix && fix_table_head.length > 0) ||
      (is_free && fix_table_head.length === 0))
  ) {
    mid_promote_icon = is_promote_dom
  }
  if (avatar_key.indexOf(key) !== -1) {
    let pic = item[key]
    // 图片类型
    // let prefix = `<div class="c-w rel">`;
    let prefix = ''
    let mid_img_prefix = `<div class="icon-wrap">`
    let mid_img_body = `<div class="imgcomp-wrap row-img-wrap">`
    let suffix = `</div></div></div>`
    if (pic) {
      mid_img_body += `<div class="wh100"><img src="${pic}" class="imgcomp-img" /></div>`
    } else {
      suffix = `<div class="imgcomp-wrap is_empty"></div></div></div>`
    }
    return (
      prefix +
      mid_promote_icon +
      mid_img_prefix +
      mid_win_icon +
      mid_img_body +
      suffix
    )
  }
  // let prefix = `<div class="c-w rel">`;
  let prefix = ''
  let txt_prefix = `<div class="text-wrap flex-v rel">`
  let class_name = 'max2line'
  if (map_key_arr.length > 1 && key !== 'country') {
    class_name = 'ellipsis'
  }
  let value = item[key]
  if (
    (!value && typeof value !== 'number') ||
    (typeof value === 'string' && !value.trim())
  ) {
    value = '-'
  }
  let txt = `<div class="${class_name}">${value}</div>`
  let suffix = `</div></div>`
  return prefix + mid_promote_icon + txt_prefix + txt + mid_win_icon + suffix
}

export function urlQuery(parse_str) {
  let queryStr
  if (!!parse_str) {
    queryStr = parse_str
  } else {
    queryStr = window.location.search
  }
  if (queryStr.indexOf('?') === 0 || queryStr.indexOf('#') === 0) {
    queryStr = queryStr.substring(1, queryStr.length)
  }
  let queryObj = {}
  let tt = queryStr.split('&')
  for (let i in tt) {
    let ss = typeof tt[i] == 'string' ? tt[i].split('=') : []
    if (ss.length == 2) {
      queryObj[ss[0]] = decodeURIComponent(ss[1])
    }
  }
  return queryObj
}

export let queryObj = urlQuery()

// throttle 和 debouce 函数的底层实现
let limit = function (func, wait, debounce) {
  let timeout
  return function () {
    let context = this,
      args = arguments
    // 封装函数,用于延迟调用
    let throttler = function () {
      // 只是节流函数的时候,对其timeout进行赋值为null,这样可以设置下一次的setTimtout
      timeout = null
      func.apply(context, args)
    }
    // 如果debouce是true的话,前一个函数的调用timeout会被清空,不会被执行
    // 就是debounce函数的调用,这个前一个函数的不会执行.下面会重新设定setTimeout用于
    // 执行这一次的调用.
    // 但是如果是throttle函数,则会执行前一个函数的调用,同时下面的setTimeout在
    // 函数没有运行的时候,是无法再次设定的.
    if (debounce) clearTimeout(timeout)
    // 如果debouce是true 或者 timeout 为空的情况下,设置setTimeout
    if (debounce || !timeout) timeout = setTimeout(throttler, wait)
  }
}

// throttle 节流函数
export function throttle(func, wait) {
  return limit(func, wait, false)
}

// debouce 多次调用,只执行最后一次.
export function debounce(func, wait) {
  return limit(func, wait, true)
}

export function strlen(str) {
  if (!str) {
    return 0
  }
  var len = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    //单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
  }
  return len
}

// 深拷贝
export function deepCopy(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime())
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item)
      return arr
    }, [])
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key])
      return newObj
    }, {})
  }
}

// router. children
export function finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
) {
  return diffCompetitionTypeArr.map((competitionItem) => {
    // 需要深拷贝
    let children = deepCopy(baseChildren)
    return children.map((route) => {
      // console.debug('route:', route, route.component)
      route.name = `${route.name}_${competitionItem.name}`
      if (route.meta) {
        route.meta.pathModule[1] = competitionItem.pathModule
      }
      if (route.redirect) {
        route.redirect.name = `${route.redirect.name}_${competitionItem.name}`
      }
      if (route.children) {
        route.children.forEach((routeChild) => {
          routeChild.name = `${routeChild.name}_${competitionItem.name}`
          routeChild.meta.pathModule[1] = competitionItem.pathModule
        })
      }
      return route
    })
  })
}

// 压缩图片
export function compressBase64Image(
  base64,
  maxWidth,
  maxHeight,
  outputFormat = 'image/jpeg',
  quality = 0.7
) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      let width = img.width
      let height = img.height

      if (width > maxWidth) {
        height *= maxWidth / width
        width = maxWidth
        height = Math.round(height)
      }

      if (height > maxHeight) {
        width *= maxHeight / height
        height = maxHeight
        width = Math.round(width)
      }

      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)

      const newDataUrl = canvas.toDataURL(outputFormat, quality)
      if (canvas.remove) {
        canvas.remove()
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas)
      }
      resolve([newDataUrl, width, height])
    }
    img.onerror = reject
    img.src = base64
  })
}

// 计算base64图片多少kb
export function getBase64ImageSize(base64String) {
  // 返回的单位：kb
  // 去除Base64的数据头部分（如"data:image/png;base64,"）
  const base64WithoutPrefix = base64String.split(',')[1]
  // Base64字符串长度（字节数）
  const byteCount = base64WithoutPrefix.length
  // Base64字符串大约等于字节数的30%
  const estimatedSize = (byteCount * 0.75) / 1024 // 转换为KB
  // 算出的结果大概率都比实际的图片要小一些，原始图片越小误差越小，越大则误差越大（原始718KB的图片误差在10kb左右，82kb图片误差在2kb左右）
  return estimatedSize.toFixed(2) // 保留两位小数
}

// 获取图片类型
export function getImgFileType(imgFile) {
  // 获取 imgFile 图片类型（.png|.jpg|.jpeg）
  let imageType = ''
  if (imgFile.indexOf('data:image/') > -1 && imgFile.indexOf(';base64') > -1) {
    // 说明是base64图片
    const arr = imgFile.split(';base64')
    imageType = arr[0].split(':')[1]
  } else {
    // 图片路径
    const arr = imgFile.split('.')
    imageType = `image/${arr[1]}`
  }
  return imageType
}

// url2bold （是否成功待测试）
export function imageUrlBlob2Base64($axios, imageUrl, callbackFun) {
  $axios(imageUrl)
    .then((response) => response.blob())
    .then((blob) => {
      // 将Blob对象转换为bold对象
      const blobUrl = URL.createObjectURL(blob)
      const boldObject = new Blob([blob], { type: 'image/jpeg' }) // 假设图片为jpeg格式
      console.debug(blobUrl, boldObject)

      // 在这里可以使用boldObject，例如下载或者作为图片显示
      // 创建一个临时的URL，可以用作img标签的src属性
      // const imgElement = document.createElement('img')
      // imgElement.src = blobUrl
      // document.body.appendChild(imgElement)

      // let blob2Base64Data = ''
      // 创建FileReader对象
      // const reader = new FileReader()

      // 监听load事件，转换完成后触发
      // reader.addEventListener('load', function () {
      //   // 此时reader.result包含了DataURL
      //   const base64Image = reader.result
      //   // 使用base64Image，例如设置为img元素的src属性
      //   blob2Base64Data = base64Image
      // })
      // reader.addEventListener('load', callbackFun)

      // reader.readAsDataURL(boldObject)

      // 在不需要时释放对象URL
      URL.revokeObjectURL(blobUrl)
    })
    .catch((error) => {
      console.error('Error fetching image:', error)
    })
}
